/* furleza-funnel.js — Funnel drawer-uitbreidingen (C upsell, D checkout-blok, E USP).
   Laadt NA cart-furleza.js en overschrijft PATTE._renderUpsell + PATTE._renderFoot.
   Zelfstandig & terugdraaibaar: verwijder dit bestand + de <script>-regel in layout/theme.liquid. */
(function () {
  'use strict';

  function money(cents) { return '€ ' + (cents / 100).toFixed(2).replace('.', ','); }

  var GLOVE_HANDLE = 'pet-hair-removal-glove';
  var PAY = ['iDEAL', 'Klarna', 'Bancontact', 'Apple Pay', 'Google Pay', 'VISA', 'Mastercard', 'PayPal', 'Maestro', 'Amex', 'Shop Pay'];

  function apply(P) {
    var drawer = document.getElementById('cartDrawer');
    var BMIN = drawer ? parseInt(drawer.dataset.bundleMin || '2', 10) : 2;
    var BPCT = drawer ? parseFloat(drawer.dataset.bundlePct || '0.10') : 0.10;

    /* C — Upsell: Pet Hair Removal Glove */
    P._renderUpsell = function () {
      var uEl = document.getElementById('cartUpsell');
      if (!uEl) return;
      var items = this.cart || [];
      if (!items.length) { uEl.innerHTML = ''; return; }
      var inCart = items.some(function (i) {
        return i.handle === GLOVE_HANDLE || (i.url && i.url.indexOf('/products/' + GLOVE_HANDLE) !== -1);
      });
      if (inCart) { uEl.innerHTML = ''; return; }
      fetch('/products/' + GLOVE_HANDLE + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) { uEl.innerHTML = ''; return; }
          var v = (p.variants && p.variants[0]) || null;
          if (!v || v.available === false) { uEl.innerHTML = ''; return; }
          var img = p.featured_image || (p.images && p.images[0]) || '';
          if (img && img.indexOf('?') === -1) { img += '?width=112'; }
          var now = money(v.price);
          var was = (v.compare_at_price && v.compare_at_price > v.price) ? money(v.compare_at_price) : '';
          var save = (v.compare_at_price && v.compare_at_price > v.price) ? (v.compare_at_price - v.price) : 0;
          var pct = save ? Math.round(save / v.compare_at_price * 100) : 0;
          var subText = save ? ('Alleen nu: ' + pct + '% korting — bespaar ' + money(save)) : 'Perfect bij wat je net koos';
          var t = (p.title || '').replace(/"/g, '&quot;');
          var imgHtml = img
            ? '<img class="cart-upsell__img" src="' + img + '" alt="' + t + '" loading="lazy" width="56" height="56">'
            : '<div class="cart-upsell__no-img"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg></div>';
          var badge = pct ? '<span class="furleza-funnel-upsell__badge">−' + pct + '%</span>' : '';
          uEl.innerHTML =
            '<div class="cart-upsell furleza-funnel-upsell">' +
              '<h4 class="cart-upsell__title">Maak je bestelling compleet</h4>' +
              '<p class="furleza-funnel-upsell__sub">' + subText + '</p>' +
              '<div class="furleza-funnel-upsell__card">' +
                '<div class="furleza-funnel-upsell__row">' +
                  '<div class="furleza-funnel-upsell__thumb">' + imgHtml + badge + '</div>' +
                  '<div class="cart-upsell__info">' +
                    '<span class="cart-upsell__name">' + (p.title || '') + '</span>' +
                    '<span class="cart-upsell__price"><span class="furleza-funnel-upsell__now">' + now + '</span>' + (was ? ' <s class="furleza-funnel-upsell__was">' + was + '</s>' : '') + '</span>' +
                  '</div>' +
                '</div>' +
                '<button class="furleza-funnel-upsell__add" type="button" aria-label="' + t + ' toevoegen" onclick="window.PATTE.addToCart(' + v.id + ',this)">' +
                  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" width="15" height="15"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
                  'Toevoegen voor ' + now +
                '</button>' +
              '</div>' +
            '</div>';
        })
        .catch(function () { uEl.innerHTML = ''; });
    };

    /* D + E — Compacte checkout-voet: regels, 2 knoppen, trustregel, betaalchips */
    P._renderFoot = function () {
      var sub = this._subtotal();
      var disc = this.computeDiscount();
      var ship = this.computeShipping();
      var total = this.computeTotal();
      var n = this._itemCount();
      var origTotal = (this.cart || []).reduce(function (s, i) {
        var ca = (i.compare_at_price && i.compare_at_price > i.price) ? i.compare_at_price : i.price;
        return s + ca * i.quantity;
      }, 0);
      var compareSavings = origTotal - sub;
      var discLine = disc > 0
        ? '<div class="cart-foot__row cart-foot__row--discount"><span>Bundelkorting (' + Math.round(BPCT * 100) + '% op ' + BMIN + '+ items)</span><span>−' + money(disc) + '</span></div>'
        : '';
      var savingsLine = compareSavings > 0
        ? '<div class="cart-foot__row furleza-funnel-savings"><span>Totale besparing</span><span>−' + money(compareSavings) + '</span></div>'
        : '';
      var shipLabel = ship === 0 ? '<strong>Gratis</strong>' : money(ship);
      var totalWas = (origTotal > total) ? '<s class="furleza-funnel-total-was">' + money(origTotal) + '</s> ' : '';

      return (
        '<div class="cart-foot__lines">' +
          '<div class="cart-foot__row"><span>Subtotaal (' + n + ' item' + (n !== 1 ? 's' : '') + ')</span><span>' + money(sub) + '</span></div>' +
          discLine +
          savingsLine +
          '<div class="cart-foot__row"><span>Verzending</span><span>' + shipLabel + '</span></div>' +
          '<div class="cart-foot__row cart-foot__row--total"><span>Totaal</span><span>' + totalWas + money(total) + '</span></div>' +
        '</div>' +
        '<div class="ff-cta">' +
          '<button type="button" class="ff-btn-ghost" onclick="window.PATTE.closeCart()">Verder winkelen</button>' +
          '<a href="/checkout" class="ff-btn-primary">Afrekenen →</a>' +
        '</div>' +
        '<div class="ff-trust">Veilig betalen · Binnen 30 dagen retour · Voor 23:00 besteld, morgen verzonden</div>' +
        '<div class="furleza-funnel-pay ff-pay">' +
          ['iDEAL','Klarna','VISA','Mastercard','PayPal','Apple Pay'].map(function (m) { return '<span class="furleza-funnel-pi">' + m + '</span>'; }).join('') +
        '</div>'
      );
    };

    if (P.cart && typeof P.updateCartUI === 'function') {
      try { P.updateCartUI(); } catch (e) {}
    }
  }

  function boot() {
    var n = 0;
    var t = setInterval(function () {
      if (window.PATTE && typeof window.PATTE._renderFoot === 'function') {
        clearInterval(t); apply(window.PATTE);
      } else if (n++ > 80) {
        clearInterval(t); if (window.PATTE) { apply(window.PATTE); }
      }
    }, 100);
  }

  if (document.readyState !== 'loading') { boot(); }
  else { document.addEventListener('DOMContentLoaded', boot); }
})();

/* Productpagina-tekst: '30 dagen retour' → 'Binnen 30 dagen retour' (alle producttemplates) */
(function () {
  'use strict';
  function fixTrustText() {
    document.querySelectorAll('.product-trust__item').forEach(function (el) {
      el.childNodes.forEach(function (n) {
        if (n.nodeType === 3 && n.textContent.indexOf('30 dagen retour') !== -1 && n.textContent.indexOf('Binnen') === -1) {
          n.textContent = n.textContent.replace('30 dagen retour', 'Binnen 30 dagen retour');
        }
      });
    });
  }
  if (document.readyState !== 'loading') { fixTrustText(); }
  else { document.addEventListener('DOMContentLoaded', fixTrustText); }
})();
